import { render, staticRenderFns } from "./InvoiceStatusColumn.vue?vue&type=template&id=580c08a4&"
import script from "./InvoiceStatusColumn.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports